<!-- <div class="" *ngFor="let item of messageList | groupBy:'day'"> -->
<!--
    <div class="column has-text-centered timing" *ngIf="item && item.key !== 'undefined' && item.key">
        <span class="time-history">{{item.key}}</span>
      </div> -->
<div class="" *ngFor="let message of messageList; let i = index;  trackBy: trackByFn;">
  <div class="column has-text-centered timing" *ngIf="message?.showDay">
    <span class="time-history">{{message.day}}</span>
  </div>

  <div class="msg-z-view">
    <div class="column is-clearfix" *ngIf="loggedUserId == message.from_user_id">
      <!-- <div id="messageAction" class="popover message-actions-popover-container am-fade top-right" [ngClass]="{'is-active': isActive[message.message_id]}" *ngIf="isUserRole == 1">
        <div class="message-actions" >
          <div role="menu">
            <span class="read-receipt-block" data-title="Edit" aria-label="Edit" (click)="editChatMessage(i)">
              <i class="fa fa-pencil is-size-6" aria-hidden="true"></i>
            </span>
            <span class="read-receipt-block" data-title="Delete" aria-label="Delete" (click)="deleteChatMessage(i)">
              <i class="fa fa-trash is-size-6" aria-hidden="true" ></i>
            </span>
            <span class="read-receipt-block" data-title="Pin" aria-label="Pin" (click)="handlePinTask(message.message_id)">
              <i class="fa fa-thumb-tack is-size-6" aria-hidden="true" ></i>
            </span>
            <span class="read-receipt-block" data-title="More Options" aria-label="More Options" >
              <i class="fa fa-ellipsis-h is-size-6" aria-hidden="true" ></i>
            </span>
          </div>
        </div>
      </div> -->

      <div class="is-pulled-right has-text-centered">
        <figure class="image is-32x32">
          <empty-uname [userName]="message.first_name" [detailHeadProfile]="true" *ngIf="!message.user_icon"></empty-uname>
          <img [src]="profileUrl+message.user_icon" *ngIf="message.user_icon">
        </figure>
        <!-- <i class="fa fa-ellipsis-h" aria-hidden="true"></i> -->
      </div>

      <div class="box chat-file-type is-pulled-right oposite" (mouseover)="hoverInMessageHandler(message.message_id)">
        <article class="media right-top">
          <div class="media-content">
            <div class="content">
              <strong class="is-size-7">{{message.first_name + ' '+ message.last_name}}</strong>
              <span class="chat-time">{{message.createdAt | date: 'shortTime' }}</span>
              <span class="message-update has-text-right" *ngIf="loggedUserId === message.from_user_id">
                <span class="read-receipt-block" *ngIf="!message.is_delivered && !message.is_read" data-title="Sent" aria-label="Sent">
                  <i class="fa fa-check" aria-hidden="true" ></i>
                </span>
                <span class="" *ngIf="message.is_delivered || message.is_read">
                  <span *ngIf="message.is_read; else elseTemplate">
                    <span class="read-receipt-block" data-title="Seen" aria-label="Seen">
                      <i class="fa fa-check" aria-hidden="true" [ngClass]="{'read' : message.is_read}"></i>
                      <i class="fa fa-check" aria-hidden="true" [ngClass]="{'read' : message.is_read}"></i>
                    </span>
                  </span>
                  <ng-template #elseTemplate>
                      <span class="read-receipt-block" data-title="Delivered" aria-label="Delivered">
                        <i class="fa fa-check" aria-hidden="true" ></i>
                        <i class="fa fa-check" aria-hidden="true" ></i>
                      </span>
                  </ng-template>
                </span>
              </span>

              <p class="size-14 normal-chat-content file-links" >
                <!-- <span>
                    <div class="">
                      <div contenteditable="true" spellcheck="true" role="textbox" aria-multiline="true" aria-label="Edit" data-tid="cceditor-chatEdit">
                        <div [innerHTML]="message.message | limitTo:isCollapsed[i] | highlight:search | linkify | emojismart"></div>
                      </div>
                    </div>
                </span> -->
                <span [ngClass]="{'show-less': !isCollapsed[i]}" id="scrollFrame_{{i}}" [class.collapsed]="isCollapsed[i]" [innerHTML]="message.message | limitTo:isCollapsed[i] | highlight:search | linkify | emojismart" *ngIf="message.message_type === 'chat'" data-tooltip="" #scrollFrame ></span>

                <span *ngIf="message.message.length > maxLength">
                  <a class="msgShowHide" (click)="isCollapsed[i]=!isCollapsed[i]">Show {{isCollapsed[i]  ? 'Less' : 'More'}}</a>
                </span>

                <span *ngIf="message.message_type === 'file'">
                  <app-secured-image [src]="message.thumb_file_path" [classStyle]="'abc'" [fileData]="message" *ngIf="message.message_type === 'file'"></app-secured-image>
                </span>
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>

    <div class="column is-clearfix" *ngIf="loggedUserId != message.from_user_id">
      <div class="is-pulled-left has-text-centered">
        <figure class="image is-32x32">
          <empty-uname [userName]="message.first_name" [detailHeadProfile]="true" *ngIf="!message.user_icon"></empty-uname>
          <img [src]="profileUrl+message.user_icon" *ngIf="message.user_icon">
        </figure>
        <!-- <i class="fa fa-ellipsis-h" aria-hidden="true"></i> -->
      </div>
      <div class="box chat-file-type">
        <article class="media left-top">
          <div class="media-content">
            <div class="content">
              <strong class="is-size-7">{{message.first_name + ' '+ message.last_name}}</strong>
              <small class="chat-time">{{message.createdAt | date: 'shortTime' }}</small>

              <p class="size-14 normal-chat-content file-links">
                <span [ngClass]="{'show-less': !isCollapsed[i] }" [class.collapsed]="isCollapsed[i]" id="scrollFrame_{{i}}" [innerHTML]="message.message | linkify | emojismart" *ngIf="message.message_type === 'chat'"></span>


                <!-- <span *ngIf="message.message.length > maxLength">
                  <a class="msgShowHide" (click)="aftershowMoreToggle(i)">Show {{isCollapsed[i]  ? 'Less' : 'More'}}</a>
                </span> -->

                <span *ngIf="message.message_type === 'file'">
                  <app-secured-image [src]="message.thumb_file_path" [classStyle]="'abc'" [fileData]="message" *ngIf="message.message_type === 'file'"></app-secured-image>
                </span>
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>

    <div class="showAssignment">
      <div class="modal " [ngClass]="{'is-modal-active': activePinTask[message.message_id] == true}">
        <div class="modal-background"></div>
        <div class="modal-card">
          <form name="form" (ngSubmit)="f.form.valid && submittedTask(message)" #f="ngForm" novalidate>
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">
                  New Assignment
                </p>
                <button class="delete" aria-label="close" #onClose (click)="cancelTaskPin(message.message_id)"></button>
              </header>
              <div class="card-content">
                <div class="content">
                  <div class="field">
                    <div class="content">
                      <label for="" class="label">Task</label>
                      <span class="file-name-list" [innerHTML]="message.message"></span>
                    </div>
                  </div>
                  <div class="field is-horizontal">
                    <div class="field-body">
                      <div class="field">
                        <div class="content">
                          <label class="label">Assigned By</label>
                          <span>{{message.first_name}}</span>
                        </div>
                      </div>
                      <div class="field" >
                        <div class="content">
                          <label for="" class="label">Assigned To</label>
                          <div class="" *ngIf="loggedUserId != message.from_user_id && !message.group_id; else elseTemplate">
                            <span>{{message.first_name}}</span>
                          </div>
                          <ng-template  #elseTemplate>
                            <span *ngIf="message.group_id">Group</span>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="field is-horizontal">
                    <div class="field-body">
                      <div class="field">
                        <div class="content">
                          <label for="" class="label">Assignment Due Date</label>
                          <input class="input datepicker maxDateToday hasDatepicker" [ngClass]="{ 'is-invalid': f.submitted && due_date.invalid }"  type="date" name="due_date" [(ngModel)]="model.due_date" #due_date="ngModel" required>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <footer class="card-footer is-right">
                <div class="control is-pulled-right move-right">
                  <button class="button taskSubmit is-info " [disabled]="f.form.invalid">Submit Task</button>
                  <button class="button taskSubmit"  (click)="cancelTaskPin(message.message_id)">Cancel</button>
                </div>
              </footer>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
